/* eslint-disable no-undef */
import React from "react";
import ReactDOM from "react-dom";

import NextApp from "./NextApp";
import registerServiceWorker from "./registerServiceWorker";
// Add this import:
import {AppContainer} from "react-hot-loader";

// Wrap the rendering in a function:
const render = Component => {
	ReactDOM.render(
		// Wrap App inside AppContainer
		<AppContainer>
			<Component/>
		</AppContainer>,
		document.getElementById("root")
	);
};

// Inject backend URL as CSS custom property for LESS stylesheets
document.documentElement.style.setProperty(
	"--nc-principal-bg",
	`url("${process.env.REACT_APP_BACK}principal_new2.png")`
);

// Do this once
registerServiceWorker();

// Render once
render(NextApp);

// Webpack Hot Module Replacement API
if (module.hot) {
	module.hot.accept("./NextApp", () => {
		render(NextApp);
	});
}
